// import clone from 'clone';
import actions from './actions';

const initState = {
  karieUsers: [],
  isFetchingKarieUsers: false,
  isFetchingKarieUser: false,
  isFetchingResponses: false,
  isPostingChange: false,
  karieUser: {
    adherence: {},
    questionnaires: []
  },
  questionnaireResponses: [],
};

export default function (state = initState, action) {
  switch (action.type) {
    case actions.GET_KARIE_USERS:
      return {
        ...state,
        isFetchingKarieUsers: true,
      };
    case actions.GET_KARIE_USERS_SUCCESS:
      return {
        ...state,
        isFetchingKarieUsers: false,
        karieUsers: action.karieUsers
      };
    case actions.FETCH_KARIE_USER_INFO:
      return {
        ...state,
        isFetchingKarieUser: true,
        isPostingChange: false,
        questionnaireResponses: [],
      };
    case actions.FETCH_KARIE_USER_INFO_SUCCESS:
      return {
        ...state,
        isFetchingKarieUser: false,
        karieUser: action.karieUser,
        karieUserMedication: action.karieUserMedication
      };
    case actions.FETCH_KARIE_USER_INFO_ERROR:
      return {
        ...state,
        isFetchingKarieUser: false,
        karieUser: {},
        karieUserMedication: {}
      };
    case actions.FETCH_KARIE_USER_ADHERENCE:
      return {
        ...state,
        isFetchingKarieUser: true,
      };
    case actions.FETCH_KARIE_USER_ADHERENCE_SUCCESS:
      return {
        ...state,
        karieUserAdherence: action.karieUserAdherence
      };
    case actions.FETCH_KARIE_USER_MEDICATION:
      return {
        ...state,
        isFetchingKarieUser: true,
      };
    case actions.FETCH_KARIE_USER_MEDICATION_SUCCESS:
      return {
        ...state,
        karieUserMedication: action.karieUserMedication
      };
    case actions.FETCH_KARIE_USER_RESPONSES:
      return {
        ...state,
        isFetchingResponses: true,
      };
    case actions.FETCH_KARIE_USER_RESPONSES_SUCCESS:
      return {
        ...state,
        isFetchingResponses: false,
        questionnaireResponses: action.questionnaireResponses
      };
    case actions.UN_ASSIGN_DEVICE:
      return {
        ...state,
        isLoading: true,
        failureMessage: null
      }
      case actions.UN_ASSIGN_DEVICE_SUCCESS:
        return {
          ...state,
          isLoading: false,
          failureMessage: null
        }
        case actions.UN_ASSIGN_DEVICE_FAILURE:
        return {
          ...state,
          isLoading: false,
          ...action.payload
        }
    default:
      return state;
  }
}
